import { render, staticRenderFns } from "./GaragePriceInfo.vue?vue&type=template&id=226b9594&scoped=true&"
import script from "./GaragePriceInfo.vue?vue&type=script&lang=js&"
export * from "./GaragePriceInfo.vue?vue&type=script&lang=js&"
import style0 from "./GaragePriceInfo.vue?vue&type=style&index=0&id=226b9594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b9594",
  null
  
)

export default component.exports